<template>
  <div>
    <wc-data-box
      title='Details'
      :titleIcon='$store.state.icons.dataBox.details.icon'
      :titleIconColor='$store.state.icons.dataBox.details.color'
    >
      <wc-two-column-table :items='tableData'></wc-two-column-table>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      :loadingButtons='isLoading'
      :disableButtons='!isFormValid'
      title='Contact'
      :icon='$store.state.icons.modules.clients.icon'
      width='400'
      @cancel='showDialog = false'
      @save='save'
    >
      <v-form v-model='isFormValid'>
        <v-text-field
          label='Address'
          v-model='inquiryCopy.site_address'
          :rules='[rules.required]'
        ></v-text-field>
        <v-text-field
          label='City'
          v-model='inquiryCopy.site_city'
          :rules='[rules.required]'
        ></v-text-field>
        <v-text-field
          label='Province'
          v-model='inquiryCopy.site_province'
        ></v-text-field>
        <wc-postal-code-input
          v-model='inquiryCopy.site_postal_code'
        ></wc-postal-code-input>
        <v-text-field
          label='Country'
          v-model='inquiryCopy.site_country'
        ></v-text-field>
      </v-form>
    </wc-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules'
import WCPostalCodeInput from '@/components/forms/WCPostalCodeInput'

export default {
  name: 'inquiry-site',
  mixins: [formRules],
  data: () => ({
    showDialog: false,
    isFormValid: false,
    isLoading: false,
    saving: false,
    inquiryCopy: {}
  }),
  props: {
    inquiry: {
      required: true
    }
  },
  computed: {
    tableData () {
      let data = []
      if (this.inquiry) {
        data = [
          { text: 'Date Created', value: this.$options.filters.shortDate(this.inquiry.date_created) },
          { text: 'Created By', value: this.inquiry.created_by ? this.inquiry.created_by_obj.name_display : '(not set)' },
          { text: 'Status', value: this.inquiry_status }
        ]
      }
      return data
    },
    inquiry_status () {
      if (this.inquiry.archived) {
        return 'Archived'
      }
      if (!this.inquiry.archived && !this.inquiry.estimate_generated) {
        return 'Open'
      }
      if (this.inquiry.estimate_generated) {
        return 'Estimate Generated'
      }
      return '?'
    }
  },
  methods: {
    edit () {
      this.inquiryCopy = _.cloneDeep(this.inquiry)
      this.showDialog = true
    },
    save () {
      this.$emit('update', this.inquiryCopy)
      this.showDialog = false
    }
  },
  components: {
    'wc-postal-code-input': WCPostalCodeInput
  }
}
</script>
